<template>
  <!-- 応募 -->
  <div
    :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}"
    @mouseover="changeHover(true)" @mouseout="changeHover(false)">
    <transition>
      <a class="hover" :href="openImage(message)" target="_blank" rel="noopener" v-if="isHover&&!isError">
        クリック/タップで別ウィンドウで画像を開きます。
      </a>
    </transition>
    <img
      class="image-parts"
      @error="error"
      :src="imageCreate(message)"
      v-if="!isError"/>
    <div fallback v-if="isError">
      <p>本画像の有効期限が過ぎました。</p>
    </div>
  </div>
</template>

<script>
// 外部関数
import {
  imageCreate
} from "@/functions/balloonFunc"

export default {
  props: ['message', 'speaker'],
  methods: {
    imageCreate (m) {
      return imageCreate(m)
    },
    changeHover (flg) {
      this.isHover = flg
    },
    openImage (msg) {
      var urlCut = msg.indexOf("?GoogleAccessId")
      var urlFront = msg.substring(0, urlCut)
      urlFront = urlFront.replace(/\//g, "[slash]").replace("[msg][image]", "")
      var urlAfter = msg.substring(urlCut).replace("[/image][/msg]|", "")
      urlAfter = encodeURI(urlAfter).replace(/\?/g, "[question]")
      return '/image/' + urlFront + urlAfter
    },
    error () {
      this.isError = true
    }
  },
  data () {
    return {
      isHover: false,
      isError: false
    }
  }
};
</script>

<style lang="scss" scoped>
.my-box {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 10px;
  transition: 0.7s;
  position: relative
}
.other-box {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 10px;
  position: relative;
}
.hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  padding: 8px;
  z-index: 1;
}
.image-parts {
  background: rgba(0, 0, 0, 0);
  border-radius: 8px;
  min-height: 200px;
  max-height: 300px;
  object-fit: cover;
}
.v-leave-active,
.v-enter-active {
  transition: .5s ease;
  transform-origin: top;
}
.v-leave-to,
.v-enter {
  opacity: 0;
}
.v-leave,
.v-enter-to {
  opacity: 1;
}
div[fallback] {
  z-index: auto;
  background: #ccc;
  color: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  height: 200px;
  border-radius: 8px;
  p {
    text-align: center;
    vertical-align: middle;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BalloonParts/ImageParts.vue